<ul class="event-line">
	@for (event of events; track event; let i = $index) {
		<li class="event">
			<ng-template [ngTemplateOutlet]="eventTemplate" [ngTemplateOutletContext]="{ $implicit: event, index: i }" />
		</li>
	}
	@if (afterTemplate) {
		<li class="event"><ng-template [ngTemplateOutlet]="afterTemplate" /></li>
	}
</ul>
